/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AddAction/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TasksCommentTextarea from 'DesignSystem/TasksCommentTextarea/index'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function AddAction({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Content/Home/Content/Tasks/Content/CommentsLogs/Comments/AddAction",
  onChange
  
}) {
let dtColorsNeutral100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.100'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
let taskCommentCommentValueData = fromData.useDataValue({ viewPath,
context: 'task_comment',
path: 'comment',
})
let taskCommentCommentChangeData = fromData.useDataChange({ viewPath,
context: 'task_comment',
path: 'comment',
})
let taskCommentCommentValueData1 = fromData.useDataValue({ viewPath,
context: 'task_comment',
path: 'comment',
})
let constantData = ''
let aggregateData = fromAggregate.equals(taskCommentCommentValueData1, constantData)
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  onChange
  
})
  return (<React.Fragment
>
<div
  data-testid="AddAction.Vertical"
  data-view-path={viewPath}
 style={{'--bc-1-1JriDV': dtColorsNeutral100,'--pt-2-1JriDV': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-3-1JriDV': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btc-4-1JriDV': dtColorsNeutral200}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="AddAction.Vertical:1"
  data-view-path={viewPath}
 style={{'--btlr-5-1JriDV': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btrr-6-1JriDV': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bbrr-7-1JriDV': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bblr-8-1JriDV': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bc-9-1JriDV': dtColorsNeutral300}}
 className={`views-block ${styles.Vertical1}`}
>
<TasksCommentTextarea
  viewPath={`${viewPath}/TasksCommentTextarea`}
 data="task_comment.comment"
 value={taskCommentCommentValueData}
 onChange={taskCommentCommentChangeData}
/>
<div
  data-testid="AddAction.Horizontal"
  data-view-path={viewPath}
 style={{'--pt-2-1JriDV': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-10-1JriDV': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-3-1JriDV': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pl-11-1JriDV': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btc-4-1JriDV': dtColorsNeutral300}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 data="task_comment.comment"
 data="''"
 aggregate="/Data/aggregate.js equals"
 disabled={aggregateData}
 onClick={onClick}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Comment"
/>
)}
</TysiaButton>
</div>
</div>
</div>
{children}
</React.Fragment>)
}